import React, { useContext, useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';
import { styled, alpha } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Search_Produtos from '../../components/Search_Produtos/Search_Produtos';
import Search_Produtos_Mobile from '../../components/Search_Produtos_Mobile/Search_Produtos_Mobile';
import MoreIcon from '@mui/icons-material/MoreVert';
import LogoName from '../../assets/img/NAFIL_logo.svg';
import { ToastContainer, toast } from 'react-toastify';

import { MyContext } from '../../context/MyContext';

import api from '../../services/api';

import { ReactComponent as MenuIcon } from '../../assets/img/menu_off.svg';
import { ReactComponent as CarrinhoIcon } from '../../assets/img/carrinho.svg';
import { ReactComponent as UsuarioIcon } from '../../assets/img/profileNAFIL.svg';
import { ReactComponent as FaturadosIcon } from '../../assets/img/faturados_nafil.svg';
import { ReactComponent as PigCreditosIcon } from '../../assets/img/pigNafil.svg';
import { ReactComponent as DevolucaoIcon } from '../../assets/img/devolucaoNafil.svg';
import { ReactComponent as MeusPedidosIcon } from '../../assets/img/meus_pedidos.svg';
import { ReactComponent as MotoDeliveryIcon } from '../../assets/img/moto_delivery.svg';
import { ReactComponent as SaidaIcon } from '../../assets/img/saida.svg';

// import { ReactComponent as TotaisIcon } from '../../assets/img/totaisNafil.svg';

import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import { BrowserRouter as Router, Link, withRouter, NavLink } from 'react-router-dom';
import { Route, Redirect } from 'react-router';
import { RouteRounded } from '@mui/icons-material';
import { BrowserView, MobileView } from 'react-device-detect';
import { identificacaoUsuarioLogado, identificacaoRazaoSocialUsuarioLogado, identificacaoNomeUsuarioLogado } from './../../utils';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}));

const toastMensagemError = (message) => toast.error(message,
     { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });



//export default function PrimarySearchAppBar() {
export default function NavBar_Top() {
  const history = useHistory();
  // const {carrinho, setCarrinho, itemQuantidade, setItemQuantidade} = useContext(CarrinhoContext);
  // const { counter, setCounter } = useContext(ContextProvider);
  const { meuCarrinho, setMeuCarrinho } = useContext(MyContext);
  const { carrinhoCounter, setCarrinhoCounter } = useContext(MyContext);
  // const { usuarioComprasFaturadas, setUsuarioComprasFaturadas } = useContext(MyContext);
  // const {usuarioLogado, setUsuarioLogado} = useContext(MyContext);  // Armazena Criptografado o Id e Loja do Cliente

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  // const [usuarioLogado, setUsuarioLogado] = useState("");  // Armazena Criptografado o Id e Loja do Cliente
  //const [nomeUsuarioLogado, setNomeUsuarioLogado] = useState(""); // Armazena Criptografado o Nome do Usuário Logado
  const {nomeUsuarioLogado, setNomeUsuarioLogado} = useContext(MyContext);
  const [nomeFullRazaoSocialLogado, setNomeFullRazaoSocialLogado] = useState("");

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const {usuarioEfetuouLogin, setUsuarioEfetuouLogin } = useContext(MyContext);
  const {usuarioEfetuouLoginEMail, setUsuarioEfetuouLoginEMail} = useContext(MyContext);
  const { openDadosPessoais, setOpenDadosPessoais } = useContext(MyContext);
  
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  function identificacaoUsuarioLogado() {
    if (sessionStorage.getItem("id_loja_usuario") == null || sessionStorage.getItem("id_loja_usuario") == "") {
      return "";
    }
    return (Buffer.from(sessionStorage.getItem("id_loja_usuario").replace('YfhR7sFdS53a==', '').substring(2), 'base64').toString());
  }

  const deslogar = async (event) => {
      sessionStorage.removeItem("nome_razao_social_logado");
      sessionStorage.removeItem("nome_usuario_logado");
      sessionStorage.removeItem("id_loja_usuario");
      sessionStorage.removeItem("hash_usuario");
      sessionStorage.removeItem("usuario_compras_faturado");
      setUsuarioEfetuouLogin("");
      setNomeUsuarioLogado("");
      setUsuarioEfetuouLogin("");
      setUsuarioEfetuouLoginEMail("");
      setOpenDadosPessoais(false);
      history.push('/index');
      api.post(`/Login/logout`, {}, { withCredentials: true })
        .then((response) => {
          history.push('/index');
          // console.log("REsP ", response); 
        })
        .catch((error) => {
          // console.log("REsP Ruim ", error);
          if (error == "Error: Network Error") {
            toastMensagemError("Ops, Alguma Coisa Errada com Nosso Servidor!");
            return null;
          }
        });
  
      // 02/09/2023  setAtualizarPagina(true); 
    }

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const atualizarCarrinhoCounter = () => {
    let _cookieValoresArmazenados = JSON.parse(window.getCookie("nafil_carrinho"));

    if (_cookieValoresArmazenados) {

      let _NumeroProdutosSelecionados = 0;
      setMeuCarrinho(_cookieValoresArmazenados);
      // meuCarrinho.map((prod, index) => {
      _cookieValoresArmazenados.map((prod, index) => {
        _NumeroProdutosSelecionados += Number(prod.quantidade);
      });
      setCarrinhoCounter(_NumeroProdutosSelecionados ?? 0);
    }
  };

  useEffect(() => {
    atualizarCarrinhoCounter();
  }, []);


  let _usuarioLogado = identificacaoUsuarioLogado();
  let _usuarioComprasFaturadas = sessionStorage.getItem("usuario_compras_faturado");

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
  );


  // ITENS NO HAMBURGUER - MENU LATERAL
  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >

      <MenuItem>
        <Link to='/meu_carrinho' style={{ textDecoration: 'none', color: 'black' }}>
          <IconButton size="large" aria-label="Meu Carrinho" color="inherit">
            <Badge badgeContent={carrinhoCounter} color="error">
              <CarrinhoIcon style={{ color: "green" }} />
            </Badge>
          </IconButton>
          Meu Carrinho { }
        </Link>
      </MenuItem>

      {_usuarioLogado && _usuarioComprasFaturadas == 1 ? (
        <MenuItem>
          <Link to='/meus_pedidos' style={{ textDecoration: 'none', color: 'black' }}>
            <IconButton size="large" aria-label="Meus Pedidos" color="inherit">
              <MeusPedidosIcon style={{ color: "green" }} />
            </IconButton>
            Meus Pedidos
          </Link>
        </MenuItem>
      )

        :

        (
          <></>
        )
      }

      {_usuarioLogado && _usuarioComprasFaturadas == 1 ? (
        <MenuItem>
          <Link to='/logistica' style={{ textDecoration: 'none', color: 'black' }}>
            <IconButton size="large" aria-label="Logística" color="inherit">
              <MotoDeliveryIcon style={{ color: "green" }} />
            </IconButton>
            Logística
          </Link>
        </MenuItem>
      )

        :

        (
          <></>
        )
      }


      {_usuarioLogado && _usuarioComprasFaturadas == 1 ? (
        <MenuItem>
          <Link to='/faturado' style={{ textDecoration: 'none', color: 'black' }}>
            <IconButton size="large" aria-label="Compras Faturadas" color="inherit">
              <DevolucaoIcon style={{ color: "green" }} />
            </IconButton>
            Compras Faturadas
          </Link>
        </MenuItem>
      )

        :

        (
          <></>
        )
      }

      {_usuarioLogado ? (

        <MenuItem>
          <Link to='/minha_conta' style={{ textDecoration: 'none', color: 'black' }}>
            <IconButton size="large" aria-label="Minha Conta" color="inherit">
              <UsuarioIcon style={{ color: "green" }} />
            </IconButton>
            Minha Conta
          </Link>
        </MenuItem>

      )
        :
        (

          <MenuItem>
            <Link to='/cadastro' style={{ textDecoration: 'none', color: 'black' }}>
              <IconButton size="large" aria-label="Cadastrar Usuário" color="inherit">
                <DevolucaoIcon style={{ color: "green" }} />
              </IconButton>
              Cadastrar Usuário
            </Link>
          </MenuItem>

        )
      }

      {_usuarioLogado ? (

        <MenuItem onClick={(e) => deslogar(e)}>
          {/* <Link to='/saida' style={{ textDecoration: 'none', color: 'black' }}> */}
            <IconButton onClick={(e) => deslogar(e)} size="large" aria-label="Minha Conta" color="inherit">
              <SaidaIcon style={{ color: "green" }} />
            </IconButton>
            Deslogar
          {/* </Link> */}
        </MenuItem>

      )
        :
        (
          <></>
        )
      }


      {/* <MenuItem>
        <IconButton size="large" aria-label="Créditos Faturados" color="inherit">
         <PigCreditosIcon style={{ color: "green" }}/> 
        </IconButton>
        <p>Créditos Faturados</p>
      </MenuItem> */}

      {/* <MenuItem>
        <Link to='/faturado' style={{ textDecoration: 'none', color:'black' }}>
        <IconButton size="large" aria-label="Compras Faturadas" color="inherit">
         <DevolucaoIcon style={{ color: "green" }}/> 
        </IconButton>        
        Compras Faturadas
        </Link> 
      </MenuItem> */}

      {/* <MenuItem>
        <Link to='/faturado' style={{ textDecoration: 'none', color:'black' }}>
        <IconButton size="large" aria-label="Compras Faturadas" color="inherit">
         <DevolucaoIcon style={{ color: "green" }}/> 
        </IconButton>        
        Compras Faturadas
        </Link> 
      </MenuItem> */}



      {/* <MenuItem>
        <IconButton size="large" aria-label="Devoluções" color="inherit">
         <DevolucaoIcon style={{ color: "green" }}/> 
        </IconButton>
        <p>Devoluções</p>
      </MenuItem> */}

      {/* <MenuItem>
        <IconButton size="large" aria-label="Minhas Operações" color="inherit" onClick={}>
         <TotaisIcon style={{ color: "green" }}/> 
        </IconButton>
        <p>Minhas Operações</p>
      </MenuItem> */}

      {/* <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle style={{ color: "green" }} />
        </IconButton>
        <p>Profile</p>
      </MenuItem> */}
    </Menu>
  );
  const theme = useTheme();
  return (
    <>
      <BrowserView>
        <Box sx={{ flexGrow: 1, width: "100vw" }}>
          <AppBar position="static" sx={{ bgcolor: '#eafaf1' }}>
            <Toolbar>
              {/* <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="open drawer"
              sx={{ mr: 0 }}
            >
              <MenuIcon style={{ color: "green " }} />
            </IconButton> 
             */}

              <Box sx={{ marginTop: '5px', marginBottom: '5px', marginRight: '10px' }}>
                <Link to="/"><img src={LogoName} alt="NAFIL" sx={{ display: { xs: 'none', md: 'flex' } }} style={{ width: '180px', height: 'auto' }} /></Link>
              </Box>

              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                alignContent: 'center'
              }}>
                <Search_Produtos />
              </Box>

              <Box sx={{ flexGrow: 1 }} />
              <Box sx={{ display: { xs: 'flex', md: 'flex' }, marginRight: 'auto' }}>
                <IconButton size="large" aria-label="show 4 new mails" color="inherit" component={Link} to={'/meu_carrinho'}  >
                  <Badge badgeContent={carrinhoCounter} color="error">
                    <CarrinhoIcon style={{ color: "green" }} />
                  </Badge>
                </IconButton>
                {/* <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
              >
                <AccountCircle style={{ color: "green" }} />
              </IconButton> */}
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  aria-label="open drawer"
                  sx={{ ml: '5px' }}
                >
                  <MenuIcon onClick={handleMobileMenuOpen} style={{ color: "green " }} />
                </IconButton>
              </Box>

              <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                <IconButton
                  size="large"
                  aria-label="show more"
                  aria-controls={mobileMenuId}
                  aria-haspopup="true"
                  onClick={handleMobileMenuOpen}
                  color="inherit"
                >
                  {/* <MoreIcon style={{ color: "green" }} /> */}
                </IconButton>
              </Box>
            </Toolbar>
          </AppBar>
          {renderMobileMenu}
          {renderMenu}
        </Box>
      </BrowserView>

      <MobileView>
        <Box sx={{ flexGrow: 1, width: "100vw" }}>
          <AppBar position="static" sx={{ bgcolor: '#eafaf1' }}>
            <Toolbar>
              {/* <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="open drawer"
              sx={{ mr: 0 }}
            >
              <MenuIcon style={{ color: "green " }} />
            </IconButton> 
             */}

              <Box sx={{ marginTop: '5px', marginBottom: '5px', marginRight: '10px' }}>
                <Link to="/"><img src={LogoName} alt="NAFIL" sx={{ display: { xs: 'none', md: 'flex' } }} style={{ width: '180px', height: 'auto' }} /></Link>
              </Box>

              <Box sx={{
                display: { xs: 'flex', sm: 'flex' },
                alignItems: 'center',
                width: '100%',
                height: '40px',
                alignContent: 'center'
              }}>

              </Box>

              <Box sx={{ flexGrow: 1 }} />

              <Box sx={{ display: { xs: 'flex', md: 'flex' }, marginRight: 'auto', marginLeft: '18px' }}>
                <IconButton size="large" aria-label="Carrinho" color="inherit" component={Link} to={'/meu_carrinho'}  >
                  <Badge badgeContent={carrinhoCounter} color="error">
                    <CarrinhoIcon style={{ color: "green" }} />
                  </Badge>
                </IconButton>
                {/* <IconButton
                size="large"
                edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
              >
                <AccountCircle style={{ color: "green" }} />
              </IconButton> */}
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  aria-label="open drawer"
                  sx={{ ml: '40px' }}
                >
                  <MenuIcon onClick={handleMobileMenuOpen} style={{ color: "green " }} />
                </IconButton>
              </Box>

              <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                <IconButton
                  size="large"
                  aria-label="show more"
                  aria-controls={mobileMenuId}
                  aria-haspopup="true"
                  onClick={handleMobileMenuOpen}
                  color="inherit"
                >
                  {/* <MoreIcon style={{ color: "green" }} /> */}
                </IconButton>
              </Box>
            </Toolbar>

            <Box width={'93%'} marginLeft={'12px'} marginBottom={'8px'}>
              <Search_Produtos_Mobile />
            </Box>

          </AppBar>
          {renderMobileMenu}
          {renderMenu}
        </Box>
      </MobileView>
    </>

  );
}
